import React, { useState } from "react";
import axios from "axios";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import Footer from "../components/footer/Footer";

// Komponen form dalam provider reCAPTCHA
const DaftarForm = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [formData, setFormData] = useState({
    namaPerusahaan: "",
    jumlahKaryawan: "1 - 50",
    pic: "",
    whatsapp: "",
    email: "",
  });

  const [errors, setErrors] = useState({});
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleSubmit = async () => {
    if (!executeRecaptcha) {
      alert("reCAPTCHA belum siap. Coba refresh halaman.");
      return;
    }

    setIsSubmitting(true);
    try {
      // Dapatkan token reCAPTCHA v3
      const token = await executeRecaptcha("submit_form");
      await axios.post("https://tokomikro.id/daftar/ekasbon", {
        ...formData,
        "g-recaptcha-response": token,
      });

      setIsSuccessModalOpen(true);
    } catch (error) {
      console.error("Error:", error);
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors || {});
      } else if (error.response) {
        alert(`Gagal: ${error.response.data?.message || "Error server"}`);
      } else {
        alert("Gagal mengirim. Periksa koneksi internet.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeModal = () => setIsSuccessModalOpen(false);

  const isButtonDisabled =
    !formData.whatsapp || !formData.email || isSubmitting;

  return (
    <>
      <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-b from-white to-slate-50 p-4 sm:p-8">
        <div className="absolute inset-x-0 top-0 h-72 bg-[#3f6fe5]"></div>
        <div className="relative my-8 w-full max-w-xl rounded-3xl border border-white bg-white/95 p-6 shadow-2xl shadow-[#3f6fe5]/15 backdrop-blur md:p-10">
          <div className="text-center mb-6">
            <span className="section-eyebrow mb-4">Pendaftaran mitra</span>
            <h1 className="mb-4 text-4xl font-bold tracking-tight text-slate-900">e-Kasbon</h1>
            <p className="section-copy">
              Produk pinjaman yang ditujukan untuk karyawan dengan sistem
              pemotongan langsung dari gaji bulanan.
            </p>
          </div>

          <h2 className="text-xl font-semibold text-slate-800 mb-7 text-center">
            Formulir Pendaftaran
          </h2>

          <div className="space-y-5">
            {/* Nama Perusahaan */}
            <div>
              <label className="mb-1 block text-sm font-semibold text-slate-700">
                Nama Perusahaan
              </label>
              <input
                type="text"
                name="namaPerusahaan"
                value={formData.namaPerusahaan}
                onChange={handleChange}
                className={`form-control ${
                  errors.nama_perusahaan ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="PT Abcd"
                required
              />
              {errors.nama_perusahaan && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.nama_perusahaan[0]}
                </p>
              )}
            </div>

            {/* Jumlah Karyawan */}
            <div>
              <label className="mb-1 block text-sm font-semibold text-slate-700">
                Jumlah Karyawan
              </label>
              <select
                name="jumlahKaryawan"
                value={formData.jumlahKaryawan}
                onChange={handleChange}
                className={`form-control cursor-pointer ${
                  errors.jumlah_karyawan ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="1 - 50">1 - 50</option>
                <option value="51 - 100">51 - 100</option>
                <option value="100">100</option>
              </select>
              {errors.jumlah_karyawan && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.jumlah_karyawan[0]}
                </p>
              )}
            </div>

            {/* PIC */}
            <div>
              <label className="mb-1 block text-sm font-semibold text-slate-700">
                PIC HC&GA / HRD
              </label>
              <input
                type="text"
                name="pic"
                value={formData.pic}
                onChange={handleChange}
                className={`form-control ${
                  errors.pic ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="Nama PIC"
                required
              />
              {errors.pic && (
                <p className="mt-1 text-sm text-red-600">{errors.pic[0]}</p>
              )}
            </div>

            {/* WhatsApp */}
            <div>
              <label className="mb-1 block text-sm font-semibold text-slate-700">
                No. WhatsApp
              </label>
              <input
                type="tel"
                name="whatsapp"
                value={formData.whatsapp}
                onChange={handleChange}
                className={`form-control ${
                  errors.whatsapp ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="081234567890"
                required
              />
              {errors.whatsapp && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.whatsapp[0]}
                </p>
              )}
            </div>

            {/* Email */}
            <div>
              <label className="mb-1 block text-sm font-semibold text-slate-700">
                Alamat Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`form-control ${
                  errors.email ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="contoh@email.com"
                required
              />
              {errors.email && (
                <p className="mt-1 text-sm text-red-600">{errors.email[0]}</p>
              )}
            </div>

            {/* Catatan */}
            <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
              <p className="text-sm text-yellow-700">
                <strong>Catatan:</strong> Nomor WhatsApp dan alamat email wajib
                terverifikasi.
              </p>
            </div>

            {/* Tombol Submit */}
            <button
              type="button"
              onClick={handleSubmit}
              disabled={isButtonDisabled}
              className={`w-full rounded-xl py-3.5 font-semibold transition-all duration-300 ${
                isButtonDisabled
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-[#3f6fe5] text-white hover:bg-[#2f5fd8] shadow-lg shadow-[#3f6fe5]/20 hover:-translate-y-0.5"
              }`}
            >
              {isSubmitting ? "Mengirim..." : "Daftar Sekarang"}
            </button>
          </div>
        </div>
      </div>

      {/* Modal Sukses */}
      {isSuccessModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 p-4 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-3xl bg-white p-7 shadow-2xl">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <svg
                  className="h-6 w-6 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h3 className="mt-4 text-lg font-bold text-slate-900">
                Pendaftaran Berhasil!
              </h3>
              <p className="mt-2 text-slate-600">
                Mohon menunggu, pihak kami akan menghubungi kontak pic yang anda
                daftarkan.
              </p>
              <button
                onClick={closeModal}
                className="mt-4 rounded-xl bg-[#3f6fe5] px-4 py-2 font-semibold text-white transition hover:bg-[#2f5fd8]"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

// Wrapper dengan GoogleReCaptchaProvider
const DaftarPage = () => {
  const RECAPTCHA_SITE_KEY = "6LecwRMsAAAAAFumSztSamH-Rms130TuatY7Y3Cj";

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <DaftarForm />
    </GoogleReCaptchaProvider>
  );
};

export default DaftarPage;
